import React, { Component } from "react";
import {
  ReactiveBase,
} from "@appbaseio/reactivesearch";
import SingleList from "@appbaseio/reactivesearch/lib/components/list/SingleList";
import ReactiveList from "@appbaseio/reactivesearch/lib/components/result/ReactiveList";
import ResultList from "@appbaseio/reactivesearch/lib/components/result/ResultList";
import {
    Box,
    Button,
    Container,
    CardContent,
    Divider,
    Card,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableContainer,
    Paper,
    IconButton
  } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DescriptionIcon from '@mui/icons-material/Description';

const ElasticSearch = (props) => {
    const { index_name } = props
    const [opengrafana, setOpengrafana] = React.useState(false);

    const handleClickOpenGrafana = () => {
      setOpengrafana(true);
    };
  
    const handleCloseGrafana = () => {
      setOpengrafana(false);
    };

  console.log(index_name)
  console.log(process.env.REACT_APP_ELASTICSEARCH_URL)    
    return (
      <>
        <IconButton 
    onClick={handleClickOpenGrafana}
    color="primary" aria-label="add an alarm">
    <DescriptionIcon />
  </IconButton>  
      <Dialog
      open={opengrafana}
      onClose={handleCloseGrafana}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth='lg'
      fullWidth
    >
      <DialogTitle id="alert-dialog-title">{`Account ID: ${index_name}`}</DialogTitle>
      <DialogContent>
      <div className="main-container">
          <ReactiveBase
              app={index_name}
              url={`${process.env.REACT_APP_ELASTICSEARCH_URL}`} //"http://192.168.4.1:9200"
              theme={{
                colors: {
                  primaryColor: "#41ABF5"
                }
              }}
          >
            <div className="filters-search-container">
              <div className="search-container">
                <SingleList
                    size={300}
                    componentId="CountrySensor"
                    dataField="name.keyword"
                    // title="aws_es_check"
                />
              </div>
            </div>
            <div className="result-map-container">
              <ReactiveList
                  componentId="SearchResult"
                  dataField="name"
                  stream={true}
                  pagination={false}
                  size={20}
                  react={{
                    and: ['CountrySensor'],
                  }}
                  render={({ data }) => (
                    //   <ReactiveList.ResultListWrapper>
                    <React.Fragment>
                        <Divider />
                        {data.map(item => {
                        console.log(item)
                        return (
                            <React.Fragment>
                                <br />
                                <br />
                            <ResultList.Title>
                           <div className="flex column justify-space-between">
                                <span className="pub-year">
                                       Region Name: <strong>{item.name}</strong>
                                </span>&ensp;&ensp;
                                <span className="pub-year">
                                       Region Code: <strong>{item.region}</strong>
                                </span>
                            </div>                            
                          </ResultList.Title>
                                <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center">Event ID</TableCell>
            <TableCell align="center">Event Name</TableCell>
            <TableCell align="center">Event Source</TableCell>
            <TableCell align="center">Event Time</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {item.result.map((row) => (
            <TableRow key={row.eventid}>
              <TableCell  align="left">
                {row.eventid}
              </TableCell>
              <TableCell align="left">{row.eventname}</TableCell>
              <TableCell align="left">{row.eventsource}</TableCell>
              <TableCell align="left">{row.eventtime}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
                            </React.Fragment>
                        )})}
                            </React.Fragment>
                    //   {/* </ReactiveList.ResultListWrapper> */}
                  )}
              />
            </div>
          </ReactiveBase>
        </div>

      </DialogContent>
      <DialogActions>
        {/* <Button onClick={handleCloseGrafana} color="primary">
          Disagree
        </Button> */}
        <Button onClick={handleCloseGrafana} color="primary" autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>        
    </>
    );
}
export default ElasticSearch;